export default "__VITE_ASSET__38214013__"